import StrikezoneGame from './StrikezoneGame';

export default StrikezoneGame;
